module.exports = __webpack_public_path__ + "img/SA.ebca323e.svg";